/* mc-drawer.js — the basket inside the order surface.

   Quantity, removal, and parking a configured piece so a second one can
   be configured behind it. Everything runs against Shopify's own cart:
   line-item properties are already the per-piece store the dedication
   needs, they survive a reload, and the worker accepts a lineItems
   array — so nothing here builds a second basket in localStorage that
   can disagree with the first.

   Dawn's cart-drawer.js is NOT used. It needs trapFocus,
   removeTrapFocus and onKeyUpEscape from global.js and CartItems from
   cart.js, and this theme deliberately loads none of Dawn's JS bundle.
   Pulling it in means pulling those four too, which is exactly the
   version mixing the brief rules out.

   There is no slide-over panel either, and the reason is at the bottom
   of this file rather than buried here — it is a deliberate deviation
   from the handover and worth reading before someone "fixes" it.

   Re-render strategy: after a cart mutation, refetch this page and swap
   the basket markup. It costs one HTML request on an action nobody
   performs in a loop, and it keeps the rendering in Liquid — the line's
   dedication, its delivery label and the split-shipment sentence are
   already decided there, and reimplementing them in JS is how the two
   copies start disagreeing. */
(function () {
  'use strict';

  /* Two hosts now. [data-bh-cod] is the product page's order surface;
     [data-mc-cart-root] is /cart, where the same basket sits above the
     sheet instead of above the form. The behaviour is identical, so the
     only thing that differs is what counts as "the page". */
  var root = document.querySelector('[data-bh-cod], [data-mc-cart-root]');
  if (!root) return;

  var IS_CART = root.hasAttribute('data-mc-cart-root');

  var busy  = false;

  /* ---------- cart mutations ------------------------------ */

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refresh() {
    /* Whole page, then take the piece that changed. Section Rendering
       would be lighter, but it keys on a section id that lives in
       templates/product.json — rename the section there and this breaks
       silently, in the basket, on a live shop. */
    return fetch(location.href, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc  = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-mc-basket]');
        var here = document.querySelector('[data-mc-basket]');

        /* Emptied. On the product page the basket simply goes; on /cart
           the basket IS the page, and what should be on screen is the
           empty-cart state with its way back to the shop — which is
           Liquid, in this same template, one reload away. */
        if (!next && here) {
          if (IS_CART) { location.reload(); return; }
          here.remove();
          return;
        }
        if (next && here)  { here.replaceWith(next); return; }
        if (next && !here) {
          var host = document.querySelector('[data-mc-basket-slot]');
          if (host) host.appendChild(next);
        }
      })
      .catch(function () {
        /* A failed refresh must not leave the screen lying about the
           basket. The cart is authoritative and the server already
           accepted the change, so reload rather than guess. */
        location.reload();
      });
  }

  /* Objavljeno, da i ono sto nije dio ladice moze reci „korpa se
     promijenila". Sekcija „Slozi kombinaciju" pise u korpu preko
     /cart/add.js, a kosara koju COD forma salje se ispisuje iz Liquida
     pri ucitavanju stranice — bez ovoga bi komad usao u korpu, brojac
     bi se povecao, a narudzba bi otisla bez njega. */
  window.mcRefreshBasket = refresh;

  function change(key, qty) {
    if (busy) return;
    busy = true;
    root.setAttribute('aria-busy', 'true');
    post('/cart/change.js', { id: key, quantity: qty })
      .then(refresh)
      .then(function () {
        /* Said out loud rather than called directly: on /cart the order
           sheet holds the same money — subtotal, shipping, the amount on
           the button — and it read that money once, on load. It has to
           hear about this. An event rather than a function call because
           either file may be the one that failed to load, and neither
           should take the other down with it. */
        document.dispatchEvent(new CustomEvent('mc:cart-changed'));
      })
      .catch(function () { location.reload(); })
      .finally(function () {
        busy = false;
        root.removeAttribute('aria-busy');
      });
  }

  /* Delegated: the basket is replaced wholesale on every change, so
     listeners bound to individual rows would not survive the first one. */
  document.addEventListener('click', function (e) {
    var line = e.target.closest && e.target.closest('[data-mc-line]');
    if (!line) return;
    var key = line.dataset.key;
    var input = line.querySelector('[data-mc-qty-input]');
    var n = input ? parseInt(input.value, 10) || 1 : 1;

    if (e.target.closest('[data-mc-remove]')) { e.preventDefault(); change(key, 0); }
    else if (e.target.closest('[data-mc-plus]'))  { e.preventDefault(); change(key, Math.min(10, n + 1)); }
    else if (e.target.closest('[data-mc-minus]')) { e.preventDefault(); change(key, Math.max(0, n - 1)); }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-mc-qty-input]')) return;
    var line = e.target.closest('[data-mc-line]');
    if (!line) return;
    var n = parseInt(e.target.value, 10);
    if (isNaN(n) || n < 0) n = 1;
    change(line.dataset.key, Math.min(10, n));
  });

  /* ---------- add another gift ---------------------------- */
  /* Puts the piece being configured into the cart WITH its dedication,
     so a second one can be configured behind it. This is the only way
     two different texts can exist at once — one product page holds one
     dedication at a time. */

  var addBtn = document.querySelector('[data-mc-add-another]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (busy) return;
      var variantEl = root.querySelector('[data-bh-variant]');
      var id = variantEl && variantEl.value;
      if (!id) return;

      var props = {};
      document.querySelectorAll('[data-mc-dedication] input[name^="properties["]').forEach(function (i) {
        var m = i.name.match(/^properties\[(.+)\]$/);
        if (m && i.value) props[m[1]] = i.value;
      });

      /* Kolicina sa brojaca, ne jedinica. Ko izabere tri komada pa pritisne
         „dodaj u korpu", u korpu moraju uci tri — inace parkiranje tiho
         pojede dva i to se vidi tek na racunu kod vrata. */
      var qEl = root.querySelector('[data-bh-qty-input]');
      var q = qEl ? parseInt(qEl.value, 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      if (q > 10) q = 10;

      busy = true;
      addBtn.disabled = true;
      var label = addBtn.textContent;
      post('/cart/add.js', { id: id, quantity: q, properties: props })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refresh();
        })
        .then(function () {
          /* Parkiran komad je iznad forme, a dugme je ispod izbora — ko
             klikne, gleda u dio ekrana na kojem se nista nije promijenilo.
             Zato dugme kaze sta je sljedeci potez, i korpa se dovede pred
             oci. Bez ovoga se klikne drugi put i naruce se tri komada. */
          /* Brojac nazad na jedan. Ostao bi na tri, a tri su vec parkirana
             — sljedeci izbor bi krenuo od broja koji je vec potrosen. */
          if (qEl) {
            qEl.value = 1;
            qEl.dispatchEvent(new Event('change', { bubbles: true }));
          }

          var done = addBtn.getAttribute('data-done-label');
          if (done) addBtn.textContent = done;
          addBtn.setAttribute('data-done', '1');
          var b = document.querySelector('[data-mc-basket]');
          if (b && b.scrollIntoView) {
            b.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          setTimeout(function () {
            addBtn.textContent = label;
            addBtn.removeAttribute('data-done');
          }, 4000);
        })
        .catch(function () { location.reload(); })
        .finally(function () { busy = false; addBtn.disabled = false; });
    });
  }

  /* ---------- why there is no slide-over panel ------------
     The handover calls this a drawer. It is built as a panel INLINE on
     the buy surface instead, and that is a deliberate deviation.

     Everything §4 asks the drawer to hold is here and on one surface:
     the lines, a dedication per line, a delivery label per line, the
     split-shipment sentence, the form, the total, and the phone number.
     What is missing is only that it slides over the page.

     Moving it into an overlay would mean moving the COD form into an
     overlay, and that form is the payment path — it owns focus handling
     on validation failure, the sticky CTA's jump target, scroll position
     after an error, and the confirmation pane that replaces it in place.
     Rebuilding those four inside a focus-trapped overlay is a real risk
     taken for a visual difference, on the one part of this theme where a
     mistake costs money rather than looks.

     The sticky CTA already performs the drawer's job: it scrolls to this
     surface, which is what a drawer opening would have shown. If the
     overlay is wanted anyway, this is the seam to build it on — the
     basket markup and the form are already siblings inside a single
     [data-bh-cod] root, so a panel wraps that root and nothing inside
     needs to change.
  */
})();

